import { Form } from 'antd';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { platformApiService } from 'service/api/platformApiService';
import { PlatformInterface } from 'type/platformType';
import * as Component from '../../../../shared/components';
import * as ContractComponent from './components';
import { detailHandlers } from './handlers';

const ContractAdd: React.FC = () => {
  const [form] = Form.useForm();
  const [platformList, setPlatformList] = useState<PlatformInterface[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const { handleOnClickAddButtonClick } = detailHandlers({ id: '0', form, navigate });

  const fetchPlatform = async (): Promise<void> => {
    const platformData = await platformApiService.fetchPlatformList();
    setPlatformList(platformData);
  };

  useEffect(() => {
    fetchPlatform().then(() => {
      setIsLoading(false);
    });
  }, []);

  return (
    <Component.BasePageComponent>
      {isLoading ? (
        <Component.LoadingSpinnerComponent />
      ) : (
        <ContractComponent.DetailComponent
          form={form}
          companyList={[]}
          platformList={platformList}
          actionTitle="ADD"
          handleOnClickButtonClick={handleOnClickAddButtonClick}
        />
      )}
    </Component.BasePageComponent>
  );
};

export default observer(ContractAdd);
